import { CommonModule, NgFor } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseCardComponent } from '@fuse/components/card';
import { TFMService } from 'app/mock-api/tfm.service';
import { SlickCarouselModule } from 'ngx-slick-carousel';


@Component({
  selector: 'app-deals-type03',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule,MatIconModule,SlickCarouselModule,MatIconModule,FuseCardComponent,MatTooltipModule,NgFor],
  templateUrl: './deals-type03.component.html',
  styleUrl: './deals-type03.component.scss'
})
export class DealsType03Component implements OnInit {

  
  public view: any = { 
    cruises: [
    {
      imgSrc: 'https://media.architecturaldigest.com/photos/5654e91c587d37cb3479de02/16:9/w_2560%2Cc_limit/regent-seven-seas-lede.jpg',
      logoSrc: 'https://st2.depositphotos.com/5943796/8673/v/380/depositphotos_86734844-stock-illustration-s-blue-initial-company-swoosh.jpg',
      cruiseCode: 'CC3ICON250502',
      title: '3-Nts Iconic Aegean',
      shipName: 'Celestyal Discovery',
      route: 'Athens to Athens',
      dateRange: '1 - 4 Nov 2024',
      price: 'R 2000',
      routerLink: '/cruise-details'
    },
    {
      imgSrc: 'https://i.natgeofe.com/n/075e4f53-f271-4f7a-855a-5eccdba43587/01_Europe.jpg?w=2880&h=1920',
      logoSrc: 'https://upload.wikimedia.org/wikipedia/commons/9/92/Random_Encounters_%22RE%22_logo.png',
      cruiseCode: 'CC3ICON240511',
      title: '5-Nts Northern Europe',
      shipName: 'Viking Sea',
      route: 'Copenhagen to Stockholm',
      dateRange: '12 - 17 Dec 2024',
      price: 'R 5000',
      routerLink: '/cruise-details'
    },
    {
      imgSrc: 'https://worldwildschooling.com/wp-content/uploads/2024/07/Epic-Adventures-for-Couples-in-the-Caribbean_Snorkeling-at-the-Barrier-Reef-Belize_%C2%A9-Tropical-Studio_Adobe-Stock_384952613.jpg',
      logoSrc: 'https://s.tmimgcdn.com/scr/245400/x-letter-logo-template-vector-design_245480-original.gif',
      cruiseCode: 'CC3ICON250111',
      title: '7-Nts Caribbean Adventure',
      shipName: 'Royal Caribbean',
      route: 'Miami to Nassau',
      dateRange: '5 - 12 Jan 2025',
      price: 'R 8000',
      routerLink: '/cruise-details'
    },
    {
      imgSrc: 'https://media.wsimag.com/attachments/0df031c273793f75be23b9010507030dcaaa82e6/store/fill/1090/613/24140289eafa892ad867790b53dfb3c307ad960e5404a588eebc781a493b/Jamaica-rum-capital-of-the-world.jpg',
      logoSrc: 'https://img.freepik.com/premium-vector/x-letter-logo-vector_667864-746.jpg?semt=ais_hybrid',
      cruiseCode: 'CC3ICON240222',
      title: '4-Nts Mediterranean Magic',
      shipName: 'MSC Meraviglia',
      route: 'Barcelona to Rome',
      dateRange: '22 - 26 Apr 2025',
      price: 'R 6000',
      routerLink: '/cruise-details'
    },
    {
      imgSrc: 'https://whitestar.co.za/wp-content/uploads/2019/09/AlaskaBanner.jpg',
      logoSrc: 'https://mir-s3-cdn-cf.behance.net/project_modules/hd/e4c02d32431337.5605bf79cdb42.jpg',
      cruiseCode: 'CC3ICON240822',
      title: '10-Nts Alaska Voyage',
      shipName: 'Norwegian Bliss',
      route: 'Vancouver to Seward',
      dateRange: '1 - 10 Jun 2025',
      price: 'R 15000',
      routerLink: '/cruise-details'
      },
     {
      imgSrc: 'https://waterfrontcharters.co.za/wp-content/uploads/coastal-motor-cruise-gallery2.jpg',
      logoSrc: 'https://s3-alpha.figma.com/hub/file/1913095808/a7bdc469-cd70-4ea1-bb57-b59204ad8182-cover.png',
      cruiseCode: 'CC3ICON240822',
      title: '10-Nts cape town',
      shipName: 'Norwegian Bliss',
      route: 'Vancouver to Seward',
      dateRange: '18 - 28 Jun 2025',
      price: 'R 14000',
      routerLink: '/cruise-details'
    }
  ],
  };

  constructor(private _tfmService: TFMService) { 
    
      this._tfmService.filterBundles({ rateType: 'pps', onlyActive: true }, false).then(res => {
        this.view.bundles = res;
        
        let deals;

        // Check for Array
        if(Array.isArray(this.view.bundles.content)) {
          deals = this.view.bundles.content;
        }

        //Convert to Array
        else {
          deals = Object.values(this.view.bundles.content);
        }
        // this._tfmService.log('Deals: ', deals)

        //randomize Deals
        // deals.sort(() => Math.random() - 0.5);
        
        // Get first 4 deals
        this.view.deals = deals.slice(0, 6);
        this._tfmService.log(this.view.deals);
      });
  }

  ngOnInit(): void {
    this._tfmService.getSite().then(res => {
      this.view.site = res;

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
      this._tfmService.log(this.view);

    });
  }
  slideConfig = {
    "slidesToShow": 4,
    "slidesToScroll": 4,
     responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
  };
  
  // addSlide() {
  //   this.slides.push({img: "http://placehold.it/350x150/777777"})
  // }
  
  // removeSlide() {
  //   this.slides.length = this.slides.length - 1;
  // }
  
  slickInit(e) {
    this._tfmService.log('slick initialized');
  }
  
  breakpoint(e) {
    this._tfmService.log('breakpoint');
  }
  
  afterChange(e) {
  }
  
  beforeChange(e) {
  }
  slugify(text: string): string {
      return text
        .toLowerCase()
        .trim()
        .replace(/[\s\W-|]+/g, '-'); // Replace spaces and non-word characters with a hyphen
    }


}
